import { captureException, captureMessage } from '@sentry/react';
import { ILogsManager } from './logsManager.types';

export class SentryLogsManager implements ILogsManager {
  logDebug(message: string, data: any) {
    captureMessage(message, {
      level: 'debug',
      extra: data,
    });
  }

  logInfo(message: string, data: any) {
    captureMessage(message, {
      level: 'info',
      extra: data,
    });
  }

  logError(error: Error | string, data: any) {
    captureException(error, data);
  }

  logWarning(message: string, data: any) {
    captureMessage(message, {
      level: 'warning',
      extra: data,
    });
  }
}
